import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import { fetchProfile, updateProfile, deleteProfile } from '../../services/api'; 

import SideNav from './SideNav';

const Profile = () => {
    const [profile, setProfile] = useState(null); 
    const [bio, setBio] = useState('');
    const [profilePicture, setProfilePicture] = useState(null); 
    const [editMode, setEditMode] = useState(false);
    const [error, setError] = useState(null); 
    const [confirmDelete, setConfirmDelete] = useState(false); 
    const token = localStorage.getItem('authToken'); 
    const navigate = useNavigate(); 
    const [resetToDefault, setResetToDefault] = useState(false);

    // Load user profile when the component mounts
    useEffect(() => {
        const loadProfile = async () => {
            try {
                const profileData = await fetchProfile(token);
                setProfile(profileData); 
                setBio(profileData.bio);
                setProfilePicture(profileData.profile_picture);
            } catch (err) {
                setError(err.detail || 'Error fetching profile');
                console.error('Error fetching profile:', err);
            }
        };

        loadProfile(); 
    }, [token]); 

    const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);

  const formData = new FormData();
  formData.append('bio', bio);

  if (resetToDefault) {
    // Send special value to reset the picture
    formData.append('profile_picture', 'null'); // or send nothing, depends on backend
  } else if (profilePicture) {
    formData.append('profile_picture', profilePicture);
  }

  try {
    await updateProfile(formData, token);
    setEditMode(false);
    setProfile({ ...profile, bio, profile_picture: resetToDefault ? null : profilePicture });
  } catch (error) {
    setError('Error updating profile');
    console.error('Error updating profile:', error);
  }
};



    const handleEdit = () => {
        setEditMode(true); // Enable edit mode
    };

    const confirmDeleteProfile = () => {
        setConfirmDelete(true); // Show delete confirmation modal
    };

    const handleDelete = async () => {
        if (confirmDelete) {
            try {
                await deleteProfile(token);

                // Clear user token from localStorage to log them out
                localStorage.removeItem('authToken');

                navigate('/'); // Redirect to homepage after profile deletion
            } catch (error) {
                setError('Error deleting profile');
                console.error('Error deleting profile:', error);
            }
        }
    };

    const handleLogout = () => {
        // Redirect to the Logout component
        navigate('/logout');
    };

    return (
    <div className='dashboard-background'>
        <div className='container-fluid'>
            {/* Show error message if it exists */}
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <div className="row">
                {/* Sidebar */}
                <SideNav userProfile={profile} handleLogout={handleLogout} />

                {/* Main Content */}
                <main className="col-md-9 ms-sm-auto col-lg-10 px-4 d-flex flex-column" style={{ minHeight: '100vh' }}>

                    {/* Logo stays at top */}
                    <div className="text-center mt-3 mb-4 d-flex align-items-center justify-content-center">
                        <img
                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747769920/logo_oq3zwy.png"
                            alt="Logo"
                            style={{ width: '50px', height: '50px', marginRight: '10px' }}
                        />
                        <h1 className="d-inline mb-0 fw-bold">Digis Customer Portal</h1>
                    </div>

                    {/* Centered Profile Section */}
                    <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                        <div className="text-center">
                            {/* Profile Image & Title */}
                            <div className="mb-4 d-flex align-items-center justify-content-center">
                                <img
                                    src={profilePicture ? profilePicture : "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1750587177/Group_941_hz79ux.png"}
                                    alt="Profile"
                                    style={{ width: '100px', height: '100px', borderRadius: '50%', marginRight: '10px' }}
                                />
                                <h1 className="d-inline mb-0">Profile</h1>
                            </div>

                                {/* Profile Details */}
                                <div className="mb-4">
                                    <p><strong>Bio:</strong> <a href={bio} target="_blank" rel="noreferrer">{bio}</a></p>
                                </div>


                                {/* Edit and Delete buttons */}
                            <div className="d-flex justify-content-center">
                                <button onClick={handleEdit} className="btn btn-warning mx-2 fw-bold">Edit</button>
                                {/*  
                                <button onClick={confirmDeleteProfile} className="btn btn-danger mx-2 fw-bold">Delete</button>
                                */}
                            </div>
                        </div>
                    </div>

                        {/* Edit Profile Modal */}
                        {editMode && (
                            <div className="modal fade show" id="editProfileModal" tabIndex="-1" style={{ display: 'block' }} aria-hidden="false">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title w-100 text-center fw-bold">Edit Profile</h5>
                                            <button type="button" className="btn-close" onClick={() => setEditMode(false)} aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Bio"
                                                        value={bio}
                                                        onChange={(e) => setBio(e.target.value)}
                                                        required
                                                        className="form-control"
                                                    />
                                                </div>
                                                <div className="mb-2 d-flex align-items-center">
                                                    <input
                                                        type="file"
                                                        onChange={(e) => {
                                                            setProfilePicture(e.target.files[0]);
                                                            setResetToDefault(false); // uncheck reset if uploading new image
                                                        }}
                                                        className="form-control"
                                                        disabled={resetToDefault} // disable file input if resetting
                                                    />
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="resetCheckbox"
                                                            checked={resetToDefault}
                                                            onChange={(e) => {
                                                                setResetToDefault(e.target.checked);
                                                                if (e.target.checked) setProfilePicture(null); // clear file if resetting
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor="resetCheckbox">
                                                            Revert to default image
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="modal-footer justify-content-between">
                                                    <button type="button" className="btn btn-dark fw-bold" onClick={() => setEditMode(false)}>Cancel</button>
                                                    <button type="submit" className="btn btn-primary fw-bold">Save Changes</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/* Delete Profile Confirmation */}
                    {confirmDelete && (
                        <div className="modal fade show" id="deleteConfirmationModal" tabIndex="-1" style={{ display: 'block' }} aria-hidden="false">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title w-100 text-center fw-bold">Confirm Deletion</h5>
                                        <button type="button" className="btn-close" onClick={() => setConfirmDelete(false)} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body text-center">
                                        <p>Are you sure you want to delete your profile?</p>
                                    </div>
                                    <div className="modal-footer justify-content-between">
                                        <button type="button" className="btn btn-dark fw-bold" onClick={() => setConfirmDelete(false)}>Cancel</button>
                                        <button type="button" className="btn btn-danger fw-bold" onClick={handleDelete}>Confirm</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </div>
    </div>
    );
};

export default Profile;
